/** Browser → S3 under a presigned POST policy. XHR because fetch has no upload progress. */
export function buildFormData(fields: Record<string, string>, file: File): FormData {
  const fd = new FormData();
  for (const [k, v] of Object.entries(fields)) fd.append(k, v);
  fd.append("file", file); // S3 requires the file to be the last field
  return fd;
}

export function postToS3(
  url: string,
  fields: Record<string, string>,
  file: File,
  onProgress: (fraction: number) => void,
  xhrFactory: () => XMLHttpRequest = () => new XMLHttpRequest(),
): Promise<void> {
  return new Promise((resolve, reject) => {
    const xhr = xhrFactory();
    xhr.upload.onprogress = (e) => {
      if (e.lengthComputable) onProgress(e.loaded / e.total);
    };
    xhr.onload = () =>
      xhr.status >= 200 && xhr.status < 300
        ? resolve()
        : reject(new Error(`s3 responded ${xhr.status}`));
    xhr.onerror = () => reject(new Error("upload failed"));
    xhr.open("POST", url);
    xhr.send(buildFormData(fields, file));
  });
}
